<template>
    <div class="embed-snippet" :class="{ 'is-single-line': singleLine }">
        <div class="embed-snippet-header" v-if="!singleLine">
            <span class="embed-snippet-label" v-if="label">{{ label }}</span>
            <span v-else></span>
            <kv-button
                variant="outlined"
                size="small"
                :prepend-icon="copied ? 'ui-check' : 'ui-copy-03'"
                @click="copy"
            >
                {{ copied ? t('forms-embed-copied') : t('forms-embed-copy') }}
            </kv-button>
        </div>

        <!-- i18n-validator-ignore-next-line: generated code snippet -->
        <pre
            class="embed-snippet-code"
            :class="{ 'is-single-line': singleLine }"
        ><code>{{ value }}</code></pre>

        <kv-button
            v-if="singleLine"
            class="embed-snippet-inline-copy"
            variant="outlined"
            size="small"
            :prepend-icon="copied ? 'ui-check' : 'ui-copy-03'"
            @click="copy"
        >
            {{ copied ? t('forms-embed-copied') : t('forms-embed-copy') }}
        </kv-button>
    </div>
</template>

<script>
import KvButton from "../../components/form/kv-button.vue";

export default {
    name: "EmbedSnippet",
    components: {
        "kv-button": KvButton,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: "",
        },
        singleLine: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            copied: false,
            timeoutId: null,
        };
    },
    beforeDestroy() {
        clearTimeout(this.timeoutId);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async copy() {
            if (!this.value) {
                return;
            }
            const done = () => {
                this.copied = true;
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    this.copied = false;
                }, 2000);
                this.$store.dispatch(
                    "notification/success",
                    this.t('forms-embed-copied_toast'),
                );
            };
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(this.value);
                    done();
                    return;
                }
            } catch (error) {
                // Fall through to the legacy copy path.
            }
            const helper = document.createElement("textarea");
            helper.value = this.value;
            document.body.appendChild(helper);
            helper.select();
            document.execCommand("copy");
            document.body.removeChild(helper);
            done();
        },
    },
};
</script>

<style scoped lang="less">
.embed-snippet {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;

    &.is-single-line {
        flex-direction: row;
        align-items: stretch;
        gap: 8px;
    }
}

.embed-snippet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.embed-snippet-label {
    font-size: 13px;
    font-weight: 500;
    color: #1f2a37;
}

.embed-snippet-code {
    margin: 0;
    padding: 14px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #f9fafb;
    overflow-x: auto;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
    line-height: 1.55;
    color: #111927;
    white-space: pre;
    min-width: 0;

    code {
        font: inherit;
        color: inherit;
    }

    &.is-single-line {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        padding: 10px 14px;
        white-space: nowrap;

        code {
            display: block;
            overflow-x: auto;
            white-space: nowrap;
        }
    }
}

.embed-snippet-inline-copy {
    flex-shrink: 0;
    align-self: center;
}
</style>
